export default {"src":"/_next/static/media/section7-icon1.49e18d05.svg","height":72,"width":71,"blurWidth":0,"blurHeight":0};